import { MarkdownSection } from "components/performance/PerformanceTypes";

export const parseMarkdownSections = (narrative: string): MarkdownSection[] => {
  if (!narrative || typeof narrative !== "string") {
    return [];
  }
  const headerPattern = /^## /gm;
  const parts = narrative.split(headerPattern);
  const sections: MarkdownSection[] = [];
  for (let i = 1; i < parts.length; i++) {
    const part = parts[i];
    const firstNewlineIndex = part.indexOf("\n");
    if (firstNewlineIndex === -1) {
      sections.push({
        title: part.trim(),
        content: "",
        id: `section-${i}`,
      });
    } else {
      const title = part.substring(0, firstNewlineIndex).trim();
      const content = part.substring(firstNewlineIndex + 1).trim();

      sections.push({
        title,
        content,
        id: `section-${i}`,
      });
    }
  }

  return sections;
};
